import React from 'react';

function getPaymentStatusClass(status) {
  if (status === 'completed') return 'bg-[#00FF66]/10 text-[#00FF66]';
  if (status === 'initiated') return 'bg-yellow-500/10 text-yellow-500';
  return 'bg-[#FF3333]/10 text-[#FF3333]';
}

export function AdminTransactionsTab({ transactions }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Payment Transactions
        </h1>
        <span className="text-[#71717A]">{transactions.length} transactions</span>
      </div>
      
      <div className="bg-[#141417] border border-[#27272A] rounded-md overflow-hidden">
        <table className="data-table">
          <thead>
            <tr className="bg-[#09090B]">
              <th>Session ID</th>
              <th>User</th>
              <th>Course</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map(t => (
              <tr key={t.session_id}>
                <td className="text-[#71717A] font-mono text-xs">{t.session_id.substring(0, 20)}...</td>
                <td className="text-[#A1A1AA]">{t.user_email}</td>
                <td className="text-white">{t.course_id}</td>
                <td className="text-white font-mono">${t.amount} {t.currency?.toUpperCase()}</td>
                <td>
                  <span className={`px-2 py-1 rounded-sm text-xs ${getPaymentStatusClass(t.payment_status)}`}>
                    {t.payment_status}
                  </span>
                </td>
                <td className="text-[#71717A] font-mono text-sm">
                  {new Date(t.created_at).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
